import { AutogenModelIfuelControl, AutogenRowIfuelControl } from "./autogen/AutogenModelIfuelControl";

export class ModelIfuelControl extends AutogenModelIfuelControl<RowIfuelControl> {
	constructor() {
		super(RowIfuelControl);
	}
}

export class RowIfuelControl extends AutogenRowIfuelControl {
}